import { Avatar, Box } from "@mui/material";
import { map } from "lodash";
import TabelaBase, {
  CelulaData,
  CelulaTexto,
  CelulaValor as CelulaMoeda,
  CelulaPercentual,
} from "./tabelaBase";
import Ticker from "../ui/ticker";
import { EventoCarteira } from "../../../models/eventoCarteira";

type Props = {
  eventos: EventoCarteira[];
};

export default function TabelaEventos({ eventos }: Props) {
  const header: {
    titulo: string;
    key: string;
    ordem: number;
    align: "left" | "center" | "right";
  }[] = [
    { titulo: "Data Evento", key: "dataEvento", ordem: 1, align: "center" },
    { titulo: "Ativo", key: "ativo", ordem: 2, align: "center" },
    { titulo: "Tipo", key: "tipo", ordem: 3, align: "center" },
    { titulo: "Ação", key: "acao", ordem: 4, align: "center" },
    { titulo: "Data Ex", key: "dataEx", ordem: 5, align: "center" },
    { titulo: "Data Crédito", key: "dataCredito", ordem: 5, align: "center" },
    { titulo: "Valor", key: "valor", ordem: 7, align: "right" },
    { titulo: "Fator", key: "fator", ordem: 8, align: "right" },
  ];

  const rows = map(eventos, (evento) => ({
    dataEvento: <CelulaData data={evento.dataEvento} />,
    dataEx: <CelulaData data={evento.dataEx} />,
    dataCredito: <CelulaData data={evento.dataCredito} />,
    ativo: celulaAtivo(evento),
    tipo: celulaTipo(evento),
    acao: celulaAcao(evento),
    valor: celulaValor(evento),
    fator: celulaFator(evento),
  }));

  return <TabelaBase header={header} rows={rows} />;

  function celulaTipo(evento: EventoCarteira): JSX.Element {
    return <CelulaTexto texto={evento.tipo} />;
  }

  function celulaAcao(evento: EventoCarteira): JSX.Element {
    return <CelulaTexto texto={evento.acao} />;
  }

  function celulaAtivo(evento: EventoCarteira): JSX.Element {
    return (
      <Box
        display="flex"
        flexDirection={"row"}
        justifyContent="center"
        alignItems={"baseline"}
      >
        <Ticker codigoAtivo={evento.codigoAtivo} color="primary" />
        {"codigoObjeto" in evento && evento.codigoObjeto && (
          <>
            <Box pr={1} />
            <Ticker
              startIcon={<Avatar>➡️</Avatar>}
              codigoAtivo={evento.codigoObjeto}
            />
          </>
        )}
      </Box>
    );
  }

  function celulaValor(evento: EventoCarteira): JSX.Element {
    return evento.valor ? (
      <CelulaMoeda valor={evento.valor} />
    ) : (
      <CelulaTexto texto="-" />
    );
  }

  function celulaFator(evento: EventoCarteira): JSX.Element {
    return evento.fator ? (
      <CelulaPercentual numero={evento.fator} escala={2} />
    ) : (
      <CelulaTexto texto="-" />
    );
  }
}
